import type { IconData } from '@stacksjs/iconify-core'

export const moneyPaymentsCalculatorApp: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M3.045 16h10.67v10.67h-9.15v-1.52h-1.52v3.05h1.52v1.52h22.86V28.2h1.53v-1.53h1.52V5.335h-1.52v-1.53h-1.53v-1.52H4.565v1.52h9.15v10.67H3.045v-9.14h-1.52v19.81h1.52Zm12.19-12.19h9.14v1.53h1.53v9.14h-10.67Zm0 12.19h10.67v9.15h-1.53v1.52h-9.14Z\"/><path fill=\"currentColor\" d=\"M18.285 22.095h4.57v1.52h-4.57Zm0-3.05h4.57v1.53h-4.57Zm0-10.66h4.57v1.52h-4.57Zm-9.14 13.71h1.52v1.52h-1.52Zm0-3.05h1.52v1.53h-1.52Zm-1.53 1.53h1.53v1.52h-1.53Zm0-9.15h1.53v-1.52h1.52v-1.52h-1.52v-1.53h-1.53v1.53h-1.52v1.52h1.52zm-1.52 10.67h1.52v1.52h-1.52Z\"/><path fill=\"currentColor\" d=\"M6.095 19.045h1.52v1.53h-1.52Zm-3.05-15.24h1.52v1.53h-1.52Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default moneyPaymentsCalculatorApp
